import type { GridFilterModel } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Syncs the Kanban GridFilterModel with the URL query string using the
 * `kanbanFilterModel` parameter. When the filter is empty, the param is removed.
 */
const useKanbanFilters = (filterModel: GridFilterModel) => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (filterModel.items.length > 0) {
      params.set('kanbanFilterModel', JSON.stringify(filterModel));
    } else {
      params.delete('kanbanFilterModel');
    }
    navigate(`?${params.toString()}`, { replace: true });
  }, [filterModel, navigate]);
};

export default useKanbanFilters;
